const ProductListCtrl = function () {};

export default ProductListCtrl;
